import { AnimatePresence } from 'framer-motion'
import { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router'
import styled from 'styled-components'
import { ThemeProvider } from 'styled-components'
import { I18nProvider } from './lib/I18nProvider'

import Checkout from './features/Checkout'
import Scanner from './features/Scanner'
import TopBar from './layout/TopBar'
import { useTheme } from './lib/hooks'
import Style from './style'

const AppWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const AppContent = styled.div`
  position: relative;
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
`

const App = () => {
  const location = useLocation()
  const themes = useTheme()

  const urlParams = new URLSearchParams(window.location.search)
  const simulateScanning = urlParams.get('simulateScanning')
  if (simulateScanning !== null) {
    console.log('[App] simulateScanning parameter value: ' + simulateScanning)
    sessionStorage.setItem('simulateScanning', simulateScanning)
  }

  useEffect(() => {
    document.title = themes.title || 'Self Checkout'
  }, [themes])

  return (
    <ThemeProvider theme={themes}>
      <I18nProvider>
        <Style />
        <AppWrapper>
          <TopBar />
          <AppContent>
            <AnimatePresence mode="wait">
              <Routes location={location}>
                <Route path="/" element={<Scanner />} />
                <Route path="/checkout" element={<Checkout />} />
              </Routes>
            </AnimatePresence>
          </AppContent>
        </AppWrapper>
      </I18nProvider>
    </ThemeProvider>
  )
}

export default App
